import React from 'react';
import { compose, mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { isDifferent } from 'utils/functions';
import Button from 'components/common/Buttons/Button';
import AssessmentQuestionFilter from 'components/threepp/assessment/Filters/QuestionFilter/AssessmentQuestionFilter';
import AssessmentParticipantFilter from 'components/threepp/assessment/Filters/ParticipantFilter/AssessmentParticipantFilter';
import { getAssessmentFilters } from 'selectors/assessmentFilters/selector';
import { PanelHeader } from 'components/common/Panel/Header';

import './AssessmentFilters.scss';

export class AssessmentFilters extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    // TODO: Fix this...
    /* eslint-disable react/forbid-prop-types */
    history: PropTypes.object.isRequired,
    assessment: PropTypes.object.isRequired,
    initialFilters: PropTypes.shape({
      assignees: PropTypes.array.isRequired,
      answered: PropTypes.array.isRequired,
      required: PropTypes.array.isRequired
    }).isRequired
    /* eslint-enable react/forbid-prop-types */
  };

  constructor(props) {
    super(props);
    this.debouncedFilterQuestions = _.debounce(this.filterQuestions, 1500);
    this.state = {
      selectedFilters: props.initialFilters
    };
  }

  // Filters
  getRequiredFilters = (value = []) => {
    console.log('getRequiredFilters called with', value);
    return { required: value };
  };

  getAssigneeFilters = (value = []) => {
    return { assignees: value };
  };

  getQuestionStatusFilter = (value = []) => {
    return { answered: value };
  };

  filterQuestions = () => {
    const { initialFilters, history } = this.props;
    const { selectedFilters } = this.state;
    const changed = isDifferent(initialFilters, selectedFilters);
    if (changed) {
      // Serialize and store filters into QP
      const filterQp = new URLSearchParams();

      // Serialize assignees & unassigned
      if (selectedFilters.assignees.length) {
        const assignees = [];
        selectedFilters.assignees.forEach(assignee => {
          if (assignee === 'unassigned') {
            filterQp.append('unassigned', 'true');
          } else {
            assignees.push(assignee);
          }
        });
        if (filterQp.has('unassigned') && selectedFilters.assignees.length === 1) {
          // don't set assignees into QP
        } else {
          filterQp.append('assignees', assignees);
        }
      }

      // Serialize 'answered' as a boolean
      if (selectedFilters.answered.length === 1) {
        const [answered] = selectedFilters.answered;
        filterQp.append('answered', answered);
      }

      // Serialize 'required' as a boolean
      if (selectedFilters.required.length === 1) {
        const [required] = selectedFilters.required;
        filterQp.append('required', required);
      }

      const qp = filterQp.toString();
      history.push({
        search: qp === '' ? '' : `${qp}`
      });
    }
  };

  updateFilterState = filter => {
    console.log('updateFilterState called');
    this.setState(
      prevState => ({
        selectedFilters: {
          ...prevState.selectedFilters,
          ...filter
        }
      }),
      this.debouncedFilterQuestions
    );
  };

  hasFilter = filters => filters.answered.length > 0 || filters.assignees.length > 0 || filters.required.length > 0;

  filterByRequired = e => {
    console.log('filterByRequired called');
    const filter = this.getRequiredFilters(e);
    this.updateFilterState(filter);
  };

  filterByParticipants = e => {
    const filter = this.getAssigneeFilters(e);
    this.updateFilterState(filter);
  };

  filterByStatus = e => {
    const filter = this.getQuestionStatusFilter(e);
    this.updateFilterState(filter);
  };

  clearAllFilters = () => {
    this.updateFilterState({ assignees: [], answered: [], required: [] });
  };

  render() {
    const { assessment, t } = this.props;
    const { selectedFilters } = this.state;
    const hasFilter = this.hasFilter(selectedFilters);
    const content = hasFilter && (
      <Button className="filter-clearAll" buttonStyle="text" onClick={this.clearAllFilters}>
        {t('assessment.filters.clearAll')}
      </Button>
    );
    return (
      <div className="filters expanded">
        <div className="filters-content">
          <PanelHeader title={t('assessment.filters.title')} content={content} />
          <AssessmentQuestionFilter
            checkedStatus={selectedFilters.answered}
            onChangeStatus={this.filterByStatus}
            checkedRequired={selectedFilters.required}
            onChangeRequired={this.filterByRequired}
          />

          <AssessmentParticipantFilter assessment={assessment} checked={selectedFilters.assignees} onChange={this.filterByParticipants} />
        </div>
      </div>
    );
  }
}

export const AssessmentFiltersHOC = compose(
  withRouter,
  withTranslation(),
  mapProps(props => ({
    t: props.t,
    history: props.history,
    assessment: props.assessment,
    initialFilters: getAssessmentFilters(props)
  }))
);

export default AssessmentFiltersHOC(AssessmentFilters);
